/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormControl  from '@mui/material/FormControl';
import FormHelperText  from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';

import MenuItem  from '@mui/material/MenuItem';
import Select  from '@mui/material/Select';

import { useStyles } from './styles'

function UISelect (props) {
    const {
        error,
        defaultValueValue = '',
        helperText,
        dataProvider = [],
        value = '',
        labelHeading = '',
        onChange = undefined,
        multiple = false,
        className = {},
        disabled = false,
        hasOutlinedLabel = true,
        inputProps = {},
        maxHeight = '240px',
    } = props;

    const classes = useStyles({
        error,
        helperText,
    });

    const [touched, setTouched] = useState(false);

    function shouldShowOutlinedLabel () {
        if (!hasOutlinedLabel) {
            return false;
        }

        if (value === '') {
            return true;
        }
        if (value || value === defaultValueValue) {
            return touched;
        }
        return true;
    }

    const [showOutlinedLabel, setShowOutlinedLabel] = useState(shouldShowOutlinedLabel());

    function getItemData (value) {
        const selected = dataProvider.filter((item) => {
            return item.value === value;
        })
        return selected[0];
    }

    useEffect(() => {
        const shouldShow = shouldShowOutlinedLabel();
        setShowOutlinedLabel(shouldShow);
    }, [value, hasOutlinedLabel]);

    /*
     * Note:
     * It's not a good practice to hard code styles on common components especially margin.
     * margin should be taken care on the actual usage of component not from inside.
     * TODO temporary used marginBottom as props
     * Optimum solution is to use a passable styles or className with defaults...
     */
    
    function renderHelperText () {
        if (helperText) {
            return helperText;
        }
  
        return '';
    }

    function renderLabel () {
        if (!labelHeading) {
            return (<React.Fragment></React.Fragment>);
        }
        
        return ( 
            <span
                className={classNames([ 'ecal-input-label', classes.label ])}>
                { labelHeading }
            </span>);
    }

    function handleChange (e) {
        if (value !== '-' && e.target.value === undefined) return;
        if (window.selectEventDisable) return;
        window.selectEventDisable = true;
        setTouched(true);
        setShowOutlinedLabel(true);
        const itemData = getItemData(e.target.value);
        if (typeof onChange === 'function') {
            onChange(e,  e.target.value, itemData);
        }
        setTimeout(() => {
            window.selectEventDisable = false;
        }, 200);
    }
    return (
        <Grid
            className={classNames([classes.container, className, 'ecal-reg-field-custom-field-please-select-a-date'])}
        >
            { renderLabel() }
            <FormControl
            variant="outlined"
            className={classNames([classes.control])}
            >
                <Select
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: maxHeight,
                                overflowY: 'auto',
                                overflowX: 'hidden',

                                // Firefox scrollbar styling
                                scrollbarColor: 'rgba(220, 220, 220, 0.678) transparent',
                                scrollbarWidth: 'thin',

                                // Webkit (Chrome, Safari, Edge) scrollbar styling
                                '&::-webkit-scrollbar': {
                                    width: '6px',
                                    backgroundColor: 'transparent',
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: 'transparent',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'rgba(220, 220, 220, 0.678)',
                                    borderRadius: '3px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                    backgroundColor: 'rgba(180, 180, 180, 0.8)',
                                },
                            },
                        },
                    }}

                    inputProps={inputProps}
                    labelId={`select-${props.id}`}
                    id={`select-${props.id}`}
                    value={value}
                    defaultValue={value}

                    onChange= {(e ) => {
                        handleChange(e);
                    }}

                    onClose={(e) => {
                        handleChange(e);
                    }}

                    onClick={(e) => {

                    }}

                    label={
                        showOutlinedLabel && labelHeading ? labelHeading : undefined
                    }
                    name={props.name}
                    className={classes.select}
                    displayEmpty
                    disabled={disabled}
                    multiple={multiple}
                >
                    {
                        dataProvider && dataProvider.map((data, index) =>
                            <MenuItem
                                className={classes.menuItem}
                                code={data.code ? data.code : ''}
                                key={index} value={data.value}
                            >{data.label}</MenuItem>
                    )}
                </Select>
            </FormControl>
            <FormHelperText
                id={'demo-simple-select-outlined'}
                className={error ? classes.helperError : '' }
            >
                { renderHelperText() }
            </FormHelperText>
        </Grid>
    );
}

UISelect.propTypes = {
    /**
     * Is this the principal call to action on the page?
     */
    dataProvider: PropTypes.any,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    labelHeading: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    placeHolder: PropTypes.string,
    multiple: PropTypes.bool,
    className: PropTypes.any,
    hasOutlinedLabel: PropTypes.bool,
    inputProps: PropTypes.any,
    maxHeight: PropTypes.string,
};

export default UISelect;
